// config/contactFieldConfig.ts
import type { FormFieldConfig } from '../components/common/FormField';

export const contactFieldConfig: {
  section: string;
  column: number;
  columns?: number;
  fields: FormFieldConfig[];
}[] = [
  {
    section: 'Contact Details',
    column: 0,
    columns: 1,
    fields: [
      { field: 'contact_name', label: 'Name', type: 'text' },
      { field: 'company', label: 'Company', type: 'text' },
      { field: 'contact_title', label: 'Job Title', type: 'text' },
      { field: 'contact_email', label: 'Email', type: 'text' },
      { field: 'contact_phone', label: 'Phone', type: 'text' },
      { field: 'contact_location', label: 'Location', type: 'text' },
      { field: 'notes', label: 'Notes', type: 'multiline' },
    ],
  },
];
